import { useSyncExternalStore } from 'react';

export type DeviceClass = 'desktop' | 'tablet' | 'mobile';

const tabletQuery = '(min-width: 768px) and (max-width: 1199px)';
const mobileQuery = '(max-width: 767px)';

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined;

  const queries = [window.matchMedia(mobileQuery), window.matchMedia(tabletQuery)];
  queries.forEach((query) => query.addEventListener('change', onChange));
  return () => queries.forEach((query) => query.removeEventListener('change', onChange));
}

function getSnapshot(): DeviceClass {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'desktop';
  if (window.matchMedia(mobileQuery).matches) return 'mobile';
  if (window.matchMedia(tabletQuery).matches) return 'tablet';
  return 'desktop';
}

function getServerSnapshot(): DeviceClass {
  return 'desktop';
}

export function useDeviceClass(): DeviceClass {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
